import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import apiRequests from "../../Component/axios/config/config";
import Loading from "../../Component/Loading/Loading";
import { Pencil } from "lucide-react";
import { MdArrowBack } from "react-icons/md";
import toast from "react-hot-toast";

export default function UserDetails() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [update, setUpdate] = useState(false);

  const [User, setUser] = useState({
    userId: "",
    userName: "",
    name: "",
    city: "",
    birthday: "",
    email: "",
    address: [],
    password: "",
    mobile: "",
    createAt: "",
    updateAt: "",
  });

  const [loading, setLoading] = useState(true);
  const [loadingEdit, setLoadingEdit] = useState(false);

  useEffect(() => {
    setLoading(true);
    apiRequests
      .get(`/api/user/v1/get-user-profile/${id}`)
      .then((response) => {
        const info = response.data.data;
        setUser({
          userId: id,
          userName: info.userName || "",
          name: info.name || "",
          city: info.city || "",
          birthday: info.birthday ? info.birthday.slice(0, 10) : "",
          email: info.email || "",
          address: info.address || [],
          password: "",
          mobile: info.mobile || "",
          createAt: info.createdAt || "",
          updateAt: info.updatedAt || "",
        });
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [update]);

  function EditUser() {
    const data = {
      userId: User.userId,
      userName: User.userName,
      name: User.name,
      city: User.city,
      birthday: User.birthday,
      email: User.email,
      mobile: User.mobile,
      address: User.address,
    };

    if (User.password && User.password.trim() !== "") {
      data.password = User.password;
    }

    setLoadingEdit(true);
    apiRequests
      .patch(`/api/user/v1/edit-user-by-admin`, data)
      .then(() => {
        toast.success("successfully updated user!");
        setUpdate(!update);
      })
      .catch(() => {})
      .finally(() => setLoadingEdit(false));
  }

  if (loading)
    return (
      <div className="p-12">
        <Loading />
      </div>
    );
  if (!User)
    return (
      <div className="text-center font-bold text-xl text-gray-500 mt-20">
        User not found
      </div>
    );

  return (
    <div className="max-w-6xl mx-auto">
      <div className="bg-white p-6">
        <div className="flex flex-col gap-8">
          <div className="p-4 flex flex-col rounded-xl gap-2 border border-gray-200 bg-gray-100">
            <h2 className="text-firstColor-shade9 text-2xl font-bold">
              Edit User Info
            </h2>

            <div className="grid grid-cols-2 md:flex md:flex-col auto-cols-auto gap-5">
              <DetailItem label="User name">
                <input
                  className="py-1 pl-2 bg-transparent outline-none w-full text-black"
                  value={User.userName}
                  onChange={(e) =>
                    setUser({ ...User, userName: e.target.value })
                  }
                />
              </DetailItem>

              <DetailItem label="Name">
                <input
                  className="py-1 pl-2 bg-transparent outline-none w-full text-black"
                  value={User.name}
                  onChange={(e) => setUser({ ...User, name: e.target.value })}
                />
              </DetailItem>

              <DetailItem label="City">
                <input
                  className="py-1 pl-2 bg-transparent outline-none w-full"
                  value={User.city}
                  onChange={(e) => setUser({ ...User, city: e.target.value })}
                />
              </DetailItem>

              <DetailItem label="Birthday">
                <input
                  className="py-1 pl-2 bg-transparent outline-none w-full"
                  type="date"
                  value={User.birthday}
                  onChange={(e) =>
                    setUser({ ...User, birthday: e.target.value })
                  }
                />
              </DetailItem>

              <DetailItem label="Mobile">
                <input
                  className="py-1 pl-2 bg-transparent outline-none w-full"
                  type="tel"
                  value={User.mobile}
                  onChange={(e) => setUser({ ...User, mobile: e.target.value })}
                />
              </DetailItem>

              <DetailItem label="Address">
                <div className="flex flex-col gap-3">
                  {User.address.map((address, index) => (
                    <div key={index} className="flex items-center gap-2">
                      <div className="flex-1 border border-gray-300 bg-white rounded-lg px-3 py-2">
                        <input
                          type="text"
                          value={address}
                          placeholder={`Address ${index + 1}`}
                          onChange={(e) => {
                            const newAddress = [...User.address];
                            newAddress[index] = e.target.value;

                            setUser({
                              ...User,
                              address: newAddress,
                            });
                          }}
                          className="w-full bg-transparent outline-none text-gray-800"
                        />
                      </div>

                      {User.address.length > 1 && (
                        <button
                          type="button"
                          onClick={() => {
                            const newAddress = User.address.filter(
                              (_, i) => i !== index,
                            );

                            setUser({
                              ...User,
                              address: newAddress,
                            });
                          }}
                          className="w-9 h-9 flex items-center justify-center rounded-lg
                       text-red-500 
                   "
                        >
                          ×
                        </button>
                      )}
                    </div>
                  ))}

                  <button
                    type="button"
                    onClick={() =>
                      setUser({
                        ...User,
                        address: [...User.address, ""],
                      })
                    }
                    className=" text-sm font-medium text-blue-600
                 hover:text-blue-700 transition"
                  >
                    + Add another address
                  </button>
                </div>
              </DetailItem>
              <DetailItem label="Email">
                <input
                  className="py-1 pl-2 bg-transparent outline-none w-full"
                  type="email"
                  value={User.email}
                  onChange={(e) => setUser({ ...User, email: e.target.value })}
                />
              </DetailItem>

              <DetailItem label="New Password">
                <input
                  className="py-1 pl-2 bg-transparent outline-none w-full"
                  type="text"
                  value={User.password}
                  onChange={(e) =>
                    setUser({ ...User, password: e.target.value })
                  }
                />
              </DetailItem>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col sm:flex-row mt-8 justify-between gap-4">
        <div className="flex gap-3 px-6">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center justify-center border-2 hover:bg-black hover:text-white border-black text-baseColor-first px-4 py-2 rounded-lg gap-2"
          >
            <MdArrowBack />
            Back
          </button>
          <button
            onClick={EditUser}
            className="flex items-center bg-buttonColor-shade6 hover:bg-buttonColor-shade7 text-white px-4 py-2 rounded-lg gap-2"
          >
            {loadingEdit ? (
              <Loading textColor={"white-0"} />
            ) : (
              <>
                <Pencil className="w-4 h-4" />
                Apply
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

const DetailItem = ({ label, children }) => (
  <div className="flex flex-col gap-3 py-2 px-3 rounded-lg">
    <span className="text-gray-900">{label} :</span>
    <div className="text-gray-500 border-2 border-black p-1 rounded-lg">
      {children}
    </div>
  </div>
);
